import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { IdentificationsFetchParamsSchemas } from 'schemas/identificationsSchemas'
import { IdentificationsFetchParamsTypes } from 'types/identifications'

export const useMemberIdentificationsFilterForm = ({
  defaultValues,
}: {
  defaultValues: IdentificationsFetchParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<IdentificationsFetchParamsTypes>({
    resolver: zodResolver(IdentificationsFetchParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
